import React from "react";
import { IconCircleFilledIcon } from "../../../../widget/common/ui/Icon";
import { Position } from "../../../../widget/common/ui/Stack";
import { ChatsContextImport } from "../../../../provider/chats/chats/chats/ChatsContextProvider";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import ChatMediaContent from "../../chat_media/ChatMediaContent";
import GroupChatInfoContent from "../../group_chat_info/GroupChatInfoContent";
import { ChatMediaContextProvider } from "../../../../provider/chats/chats/chat_media/ChatMediaContextProvider";
import { GroupChatInfoContextProvider } from "../../../../provider/chats/chats/group_chat_info/GroupChatInfoContextProvider";

const ChatSidebar = () => {
  const { sidebarShowHide, showSidebar } = ChatsContextImport();

  return (
    <>
      {showSidebar.status && (
        <div className="chat-sidebar">
          <div className="font-size-16_17 font-gotham-bold mx-4 d-center position-relative">
            {AppTranslation.text(showSidebar.title)}
            <Position right={0}>
              <IconCircleFilledIcon
                size={25}
                name="close"
                color="black"
                bgColor="bgcolor-transparent"
                handleClick={() => sidebarShowHide(false, "")}
              />
            </Position>
          </div>

          {showSidebar.title === "media" ? (
            <ChatMediaContextProvider>
              <ChatMediaContent viewType="sidebar" />
            </ChatMediaContextProvider>
          ) : showSidebar.title === "group_info" ? (
            <GroupChatInfoContextProvider>
              <GroupChatInfoContent viewType="sidebar" />
            </GroupChatInfoContextProvider>
          ) : (
            <></>
          )}
        </div>
      )}
    </>
  );
};

export default ChatSidebar;
